import {Processing} from '@ultradent/components';
import ServiceError from '@components/common/ServiceError';
import {ProductOfferingLocations} from '@components/account/find-a-dentist/ProductOfferingLocations';

export const ProductOfferingRenderer = ( props = {} ) => {
    return ( {data, loading, error} ) => {
        if ( loading ) {
            return <div className="flex justify-center">
                <Processing className="justify-center">Loading your office locations</Processing>
            </div>
        }
        if ( error || !data ) {
            return <ServiceError/>;
        }

        return <ProductOfferingLocations
            isLgpAdmin={data.customer.isAdmin}
            optInProductReorderReminder={data.customer.optInProductReorderReminder}
            list={data.customer.productOfferingLocations}/>;
    };
};
